import { useIntl } from "react-intl";
import { useCallback } from "react";
import { formatMessage } from "@formatjs/intl";
const id = "runtime_message_id";
export function useFormatRuntimeMessage() {
    const intl = useIntl();
    return useCallback((message, values, options) => {
        return formatMessage({
            locale: intl.locale,
            timeZone: intl.timeZone,
            formats: intl.formats,
            defaultLocale: intl.defaultLocale,
            defaultFormats: intl.defaultFormats,
            onError: intl.onError,
            messages: {
                [id]: message
            }
        }, intl.formatters, { id }, values, options);
    }, [intl]);
}
//# sourceMappingURL=useFormatRuntimeMessage.js.map